export const Paths = {
	root: "/portafolio/",
	tools: "/portafolio/tools",
	contact: "/portafolio/contact",
};
//root: "/portafolio/",
//"homepage": "https://pablovegaau.github.io/portafolio",
export const PathSociales = {
	github: "https://github.com/PabloVegaAU",
	facebook: "https://www.facebook.com/pablo.vegavalverde.7",
	linkedin: "https://www.linkedin.com/in/pablo-cesar-vega-valverde-aa817a1b7/",
};
